import React, { useState } from "react";
import { Formik, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Breadcrums from "../../../common/breadcrumbs";
import { globalLoader, handleServerValidations } from "../../../../../utils/commonfunction";
import * as announcementServices from "../../../services/announcement.services"; 
import { SWAL_SETTINGS } from "../../../../../utils/Constants";

const AdminNotificationAnnouncement = () => {
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);

  const breadcrumbs = [
    { title: "Dashboard", url: "/admin/dashboard" },
    { title: "Send Notification", url: "" },
  ];

  const validationSchema = Yup.object().shape({
    recipient_type: Yup.string().required("Please select recipient type"),
    title: Yup.string()
      .required("Title is required")
      .trim()
      .test("trim", "Title is required", (value) => value?.trim().length > 0),
    message: Yup.string()
      .required("Message is required")
      .trim()
      .test("trim", "Message is required", (value) => value?.trim().length > 0),
    notification_type: Yup.string().required("Please select notification type"),
  });

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <Formik
        initialValues={{
          recipient_type: "all",
          title: "",
          message: "",
          notification_type: "general",
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          Swal.fire({
            title: "Send Notification?",
            text: "This will send push notifications to selected recipients",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Send Now",
          }).then((result) => {
            if (!result.isConfirmed) return;

            globalLoader(true);
            setSubmitted(true);

            const formData = new FormData();
            formData.append("recipient_type", values.recipient_type);
            formData.append("title", values.title.trim());
            formData.append("message", values.message.trim());
            formData.append("notification_type", values.notification_type);

            announcementServices.sendNotificationAnnouncement(formData)
              .then((response) => {
                setSubmitting(false);
                globalLoader(false);

                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message || "Notification sent successfully!",
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => navigate("/admin/dashboard"), 2000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                }
              })
              .catch((error) => {
                globalLoader(false);
                setSubmitting(false);
                setSubmitted(false);
                Swal.fire({
                  icon: "error",
                  text: "Something went wrong!",
                  ...SWAL_SETTINGS,
                });
              });
          });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="row row-sm">
              <div className="col-lg-12 col-md-12 animation_fade">
                <div className="card custom-card">
                  <div className="card-body">
                    <h6 className="main-content-label mb-4">Send Push Notification</h6>

                    <div className="row row-sm">
                      {/* Recipient Type */}
                      <div className="col-md-6 form-group">
                        <label className="text-left d-flex">
                          Send To:<span className="requirestar">*</span>
                        </label>
                        <select
                          name="recipient_type"
                          className="form-control"
                          value={values.recipient_type}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="users">All Users</option>
                          <option value="astrologers">All Astrologers</option>
                          <option value="all">All (Users + Astrologers)</option>
                        </select>
                        <span className="text-danger d-flex text-left">
                          <ErrorMessage name="recipient_type" />
                        </span>
                      </div>

                      {/* Notification Type */}
                      <div className="col-md-6 form-group">
                        <label className="text-left d-flex">
                          Notification Type:<span className="requirestar">*</span>
                        </label>
                        <select
                          name="notification_type"
                          className="form-control"
                          value={values.notification_type}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="general">General</option>
                          <option value="puja">Puja</option>
                          <option value="booking">Booking</option>
                          <option value="wallet">Wallet</option>
                          <option value="withdrawal">Withdrawal</option>
                          <option value="order">Order</option>
                        </select>
                        <span className="text-danger d-flex text-left">
                          <ErrorMessage name="notification_type" />
                        </span>
                      </div>

                      {/* Title */}
                      <div className="col-md-12 form-group">
                        <label className="text-left d-flex">
                          Title:<span className="requirestar">*</span>
                        </label>
                        <input
                          name="title"
                          type="text"
                          className="form-control"
                          placeholder="e.g. New Puja Booking Available!"
                          value={values.title}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <span className="text-danger d-flex text-left">
                          <ErrorMessage name="title" />
                        </span>
                      </div>

                      {/* Message */}
                      <div className="col-md-12 form-group">
                        <label className="text-left d-flex">
                          Message:<span className="requirestar">*</span>
                        </label>
                        <textarea
                          name="message"
                          className="form-control"
                          rows="5"
                          placeholder="Your message body here..."
                          value={values.message}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <span className="text-danger d-flex text-left">
                          <ErrorMessage name="message" />
                        </span>
                      </div>

                      {/* Buttons */}
                      <div className="col-12 mt-4 text-center">
                        <button
                          className="btn btn-main-primary signbtn mr-2"
                          type="submit"
                          disabled={submitted || isSubmitting}
                        >
                          <i className="ace-icon fa fa-paper-plane bigger-110 mx-1"></i>
                          {submitted ? "Sending..." : "Send Notification"}
                        </button>
                        <button
                          className="btn ripple btn-secondary"
                          type="button"
                          onClick={() => navigate(-1)}
                          disabled={submitted}
                        >
                          <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

export default AdminNotificationAnnouncement;